import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { EnsueCollection } from "../../../../../ensue-react-system/utilities/ensue-collection";
import { footballPlayerService } from "../../../../../commons";
import { FootballAssociatedCompetition } from "../../../../../commons/models/football/football-associated-competition";

export interface IFootballPlayerCompetitionsState {
  playerCompetitionList: EnsueCollection<FootballAssociatedCompetition>;
  playerCompetitionListStatus: StatusEnum;
}

const initialState: IFootballPlayerCompetitionsState = {
  playerCompetitionList: new EnsueCollection<FootballAssociatedCompetition>(),
  playerCompetitionListStatus: StatusEnum.Idle,
};

export const fetchPlayerCompetitionList = createAsyncThunk(
  "players/fetchPlayerCompetitionList",
  async (playerId: number, thunkAPI) => {
    try {
      const playerCompetitionList = await footballPlayerService.getPlayerCompetitions(playerId);
      return playerCompetitionList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballPlayerCompetitionListSlice = createSlice({
  name: "footballPlayerCompetitionList",
  initialState: initialState,
  reducers: {
    cleanUpPlayerCompetitions(state) {
      state.playerCompetitionList = new EnsueCollection<FootballAssociatedCompetition>();
      state.playerCompetitionListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchPlayerCompetitionList.pending, (state) => {
        state.playerCompetitionListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchPlayerCompetitionList.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballAssociatedCompetition>>) => {
          state.playerCompetitionListStatus = StatusEnum.Succeeded;
          state.playerCompetitionList = action.payload;
        }
      )
      .addCase(fetchPlayerCompetitionList.rejected, (state) => {
        state.playerCompetitionListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpPlayerCompetitions } = footballPlayerCompetitionListSlice.actions;
export default footballPlayerCompetitionListSlice.reducer;
